import { ArrowLineDown } from '@phosphor-icons/react';

export default ArrowLineDown;
